import { useState } from 'react';
import { toast } from 'sonner';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';

// Quote every value and neutralize formula prefixes in spreadsheet applications.
function cell(value) {
  let text = String(value ?? '');
  if (/^[\s\uFEFF]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text)) {
    text = "'" + text;
  }
  return '"' + text.replaceAll('"', '""') + '"';
}

export default function ExportPageButton({ rows, columns, filename, disabled = false }) {
  const [exporting, setExporting] = useState(false);

  function download() {
    if (disabled || exporting || !rows.length) return;
    setExporting(true);
    let url;
    let anchor;
    try {
      const lines = [
        columns.map(column => cell(column.label)).join(','),
        ...rows.map(row => columns.map(column => cell(column.value(row))).join(',')),
      ];
      const blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
      url = URL.createObjectURL(blob);
      anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      toast.success('CSV download requested', {
        description: `${rows.length} displayed record${rows.length === 1 ? '' : 's'} included. Other pages are not included.`,
      });
    } catch {
      toast.error('Could not download this page. Please try again.');
    } finally {
      anchor?.remove();
      if (url) setTimeout(() => URL.revokeObjectURL(url), 60000);
      setExporting(false);
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      disabled={disabled || exporting || !rows.length}
      onClick={download}
      title="Downloads only the records displayed on the current page"
    >
      <ApperIcon name="Download" size={16} aria-hidden="true"/>
      {exporting ? 'Preparing CSV…' : 'Export this page'}
    </Button>
  );
}
